import { useNewCode } from '@calendly/feature-check-react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { SA_BOOK_ON_BEHALF_MOBILE_GATE } from '../constants'

/** Phone + `sa_book_on_behalf_mobile` gate: use mobile shell and step router (not desktop CalendarStep). */
export const useBookModalMobileShell = () => {
  const isPhone = useDeviceType('isPhone')
  const isBookOnBehalfMobileEnabled = useNewCode(SA_BOOK_ON_BEHALF_MOBILE_GATE)?.enabled

  return isPhone && isBookOnBehalfMobileEnabled
}
